import { PRIMARY_BUTTON_BASE_CSS_VARS } from "./Primary";
import { SECONDARY_BUTTON_BASE_CSS_VARS } from "./Secondary";

export const BUTTONS_BASE_CSS_VARS = {
  primary_button: PRIMARY_BUTTON_BASE_CSS_VARS,
  secondary_button: SECONDARY_BUTTON_BASE_CSS_VARS,
};
